module.exports = __webpack_public_path__ + "img/amazon-icon.f29f9bf7.svg";